import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../config/firebase-config';
import { notifyPermissionDenied } from '../handleCallableError';

export const existsAuctionWithPlate = async (plate, context = {}) => {
  try {
    const existsAuctionFn = httpsCallable(functions, 'existsAuctionWithPlateV2');
    const result = await existsAuctionFn({
      plate,
      operatingUnitId: context.operatingUnitId,
      dealershipId: context.dealershipId,
      requestedApp: 'dealership_web',
    });
    return result.data.exists;
  } catch (error) {
    console.error('Error verificando patente:', error);
    notifyPermissionDenied(error);
    return false;
  }
};
